import type { ComponentType } from "react";
import UnderageVerificationBanner from "./UnderageVerificationBanner";
import WebcamBanner from "./WebcamBanner";
import WebcamBannerNative from "./WebcamBannerNative";

export type AdsBannerVariant =
  | "tokens"
  | "subscription"
  | "webcam"
  | "webcam_native"
  | "underage_verification";

export type AdsBannerConfig = {
  id: AdsBannerVariant;
  Component: ComponentType;
  slot?: string;
  bannedFromPages?: string[];
  allowedPages?: string[];
  weight?: number;
};

export const ADS_BANNERS: AdsBannerConfig[] = [
  {
    id: "underage_verification",
    Component: UnderageVerificationBanner,
  },
  {
    id: "webcam",
    Component: WebcamBanner,
  },
  {
    id: "webcam_native",
    Component: WebcamBannerNative,
  },
];
